import { EndFlowManager } from './EndFlowManager'
import { EndFlowChain } from './EndFlowChain'
import { CustomerRedirectionToConfirmation } from './confirmationredirect'

/**
 * CustomerEndFlowManager is a class that defines the end flow chains for a customer user.
 * @example const manager = new CustomerEndFlowManager();
 * @example manager.massage_chain.use([func1, func2, func3]);
 * @example manager.massage_chain.do(data);
 * @example manager.massage_chain.do(data1, data2);
 * @example manager.training_chain.use([func4, func5]);
 */
export class CustomerEndFlowManager extends EndFlowManager {
    public massage_chain = new EndFlowChain([
        CustomerRedirectionToConfirmation.confirmation_massage,
    ])

    public training_chain = new EndFlowChain([
        CustomerRedirectionToConfirmation.confirmation_traening,
    ])

    public yoga_chain = new EndFlowChain([
        CustomerRedirectionToConfirmation.confirmation_yoga,
    ])

    public company_chain = new EndFlowChain([
        CustomerRedirectionToConfirmation.confirmation_company,
    ])

    public companyLead_chain = new EndFlowChain([
        CustomerRedirectionToConfirmation.confirmation_companyLead,
    ])

    public package_chain = new EndFlowChain([
        CustomerRedirectionToConfirmation.confirmation_package,
    ])

    public edit_chain = new EndFlowChain([
        CustomerRedirectionToConfirmation.confirmation_edit,
    ])

    // Type '(args: void) => Promise<any>' is not assignable to type '(args: unknown) => Promise<any>'.
    // Type 'void' is not assignable to type 'unknown'.
    // EndFlowManager and IEndFlowManager defines the type of the data for the cancellation_chain as void.
    // However CustomerEndFlowManager.cancellation_chain reads that type as unknown.
    // void is not assignable to unknown, so we need to explicitly define the type of the data for the cancellation_chain as void.
    // The '<void>' generic in the following declaration is a workaround for the above error.
    // cancellation_chain should not have any data, but our generic EndFlowChain requires a parameter.
    public cancellation_chain = new EndFlowChain<void>([
        CustomerRedirectionToConfirmation.confirmation_cancellation,
    ])
}
